import * as Yup from 'yup';

export const NewOrganisationSchema = Yup.object().shape({
  orgName: Yup.string().label('Organisation name').min(3).max(255).required(),
  orgGroup: Yup.number().label('Organisation group').required(),
  masterAdminFirstName: Yup.string()
    .label('Master administrator first name')
    .required(),
  masterAdminLastName: Yup.string()
    .label('Master administrator last name')
    .required(),
  masterAdminEmail: Yup.string()
    .label('Master administrator email address')
    .required()
    .email(),
  teamLimits: Yup.number().label('Number of teams').max(500).integer(),
  userLimits: Yup.number().label('Number of users').max(500).integer(),
  hasCreateEnquiry: Yup.boolean(),
  subscriptionStart: Yup.string().label('Subscription start date').optional(),
  subscriptionEnd: Yup.string().label('Subscription end date').optional(),
  contractRenewal: Yup.string().label('Contract renewal date').optional()
});
